import {
  KnowledgeSpace,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createKnowledgeSpaceMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: KnowledgeSpace) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[KnowledgeSpaceHandler] INSERT KnowledgeSpace ${item.spaceId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeSpace,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(
            `[KnowledgeSpaceHandler] MODIFY KnowledgeSpace ${item.spaceId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeSpace,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[KnowledgeSpaceHandler] REMOVE KnowledgeSpace ${item.spaceId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeSpace,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[KnowledgeSpaceHandler] Unknown action for KnowledgeSpace:',
            action,
          );
      }
    } catch (error) {
      log.error('[KnowledgeSpaceHandler] Handler failed:', error);
    }
  };
}
